<!-- 
A little percentage indicator.
-->
<template>
  <v-tooltip v-if="total" bottom>
    <span slot="activator">
      <v-progress-circular 
        :value="percent"
        :rotate="rotate"
        :color="color"
        class="ml-3"
        width="15"
        size="30"
        style="position:relative;top:-2px;"
      />
      <v-fade-transition>
        <span v-if="!paused" class="font-weight-regular">
          {{ percent }}%
        </span>
      </v-fade-transition>
    </span>
    <span>This component makes up approximately {{ percent }}% of the total levy</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "black"
    },
    total: {
      type: Number,
      required: true
    },
    amount: {
      type: Number,
      required: true
    },
    previousAmount: {
      type: Number,
      default: 0
    },
    delay: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      paused: true
    };
  },
  computed: {
    percent() {
      return this.paused ? 0 : Math.round((this.amount / this.total) * 100, 0);
    },
    rotate() {
      return (this.previousAmount / this.total) * 360 - 90;
    }
  },
  mounted() {
    setTimeout(() => (this.paused = false), this.delay);
  }
};
</script>
